import { APIService } from "services";

export const getDesig_Level = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllDesig_Level(pageNo,pageSize);
    }
    else{
        try {
            res = await searchDesig_Level(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data){
    return res.data;
    }else{
    return { records:[], totalCount:0 }
    }
    
}


export const addDesig_Level = (data) => {
return APIService.api().post(`/desig_level`,data)
}
export const updateDesig_Level = (desig_level_id,data) => {
return APIService.api().patch(`/desig_level/${desig_level_id}`,data)
}
export const getAllDesig_Level = (pageNo,pageSize) => {
return APIService.api().get(`/desig_level/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const getOneDesig_Level = (desig_level_id) => {
return APIService.api().get(`/desig_level/${desig_level_id}`)
}
export const searchDesig_Level = (searchKey,pageNo,pageSize) => {
return APIService.api().get(`/desig_level/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const deleteDesig_Level = (desig_level_id) => {
return APIService.api().delete(`/desig_level/${desig_level_id}`)
}
